export const LANGUAGES = [
  'pt',
  'pt-BR',
  'en',
  'en-US',
  'es',
  'es-ES',
  'it',
] as const
